"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var elog = require("../../elog");
var I18n = require("i18n-js");
var react_tracking_1 = require("react-tracking");
var lodash_1 = require("lodash");
var core_link_1 = require("../../components/core_link");
var tracker_1 = require("../../tracker");
var sanitized_render_1 = require("../../components/sanitized_render");
var url_helpers_1 = require("../../url_helpers");
var metadata_helper_1 = require("../lib/metadata_helper");
var COMPONENT_NAME = 'CspVerticalFeature';
var CspVerticalFeature = /** @class */ (function (_super) {
    tslib_1.__extends(CspVerticalFeature, _super);
    function CspVerticalFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CspVerticalFeature.prototype.getBackgroundStyle = function () {
        var img = this.props.imageOverride ?
            url_helpers_1.imageUploadURL(this.props.imageOverride) :
            this.props.csp.image.source;
        return { backgroundImage: "url(" + img + ")" };
    };
    CspVerticalFeature.prototype.getLowestPrice = function () {
        return metadata_helper_1.findLowestPrice(this.props.csp).display;
    };
    CspVerticalFeature.prototype.getUsedPrice = function () {
        return lodash_1.get(this.props.csp, 'inventory.usedLowPrice.display', null);
    };
    CspVerticalFeature.prototype.getNewPrice = function () {
        return lodash_1.get(this.props.csp, 'inventory.newLowPrice.display', null);
    };
    CspVerticalFeature.prototype.renderPlaceholder = function () {
        var classes = classNames('csp-vertical-feature', 'csp-vertical-feature--placeholder');
        return (React.createElement("article", { className: classes },
            React.createElement("div", { className: "csp-vertical-feature__image" },
                React.createElement("div", { className: "csp-vertical-feature__image__inner" })),
            React.createElement("div", { className: "csp-vertical-feature__text" })));
    };
    CspVerticalFeature.prototype.renderPrice = function () {
        if (this.props.hidePrices)
            return;
        if (!this.props.splitPrices) {
            return (React.createElement("div", { className: "csp-vertical-feature__price" },
                React.createElement("div", { className: "csp-vertical-feature__price__inner" }, I18n.t('cms.cspFeature.priceFrom', { price: this.getLowestPrice() }))));
        }
        return (React.createElement("div", { className: "csp-vertical-feature__price" },
            React.createElement("div", { className: "csp-vertical-feature__price__inner" },
                this.getNewPrice() &&
                    React.createElement("div", { className: "csp-vertical-feature__split-price" }, I18n.t('cms.cspFeature.newPriceFrom', { price: this.getNewPrice() })),
                this.getUsedPrice() &&
                    React.createElement("div", { className: "csp-vertical-feature__split-price" }, I18n.t('cms.cspFeature.usedPriceFrom', { price: this.getUsedPrice() })))));
    };
    CspVerticalFeature.prototype.renderCSPSummary = function (description) {
        var summaryFallback = this.props.useCspSummary && this.props.csp.summary;
        var summary = description || summaryFallback;
        if (!summary)
            return;
        return (React.createElement(sanitized_render_1.default, { htmlTag: "div", className: "csp-vertical-feature__description", html: summary }));
    };
    CspVerticalFeature.prototype.render = function () {
        try {
            var _a = this.props, csp = _a.csp, description = _a.description;
            var classes = classNames('csp-vertical-feature', { 'csp-vertical-feature--wide': this.props.wide });
            if (!csp)
                return this.renderPlaceholder();
            return (React.createElement("article", { className: classes },
                React.createElement("div", { className: "csp-vertical-feature__image" },
                    React.createElement(core_link_1.default, { to: csp.webLink.href, style: this.getBackgroundStyle(), entityId: csp.id, position: this.props.position })),
                React.createElement("div", { className: "csp-vertical-feature__text" },
                    React.createElement("h3", { className: "csp-vertical-feature__title" },
                        React.createElement(core_link_1.default, { to: csp.webLink.href, entityId: csp.id, position: this.props.position }, csp.title)),
                    this.renderCSPSummary(description),
                    React.createElement("div", { className: "csp-vertical-feature__footer" },
                        this.renderPrice(),
                        React.createElement(metadata_helper_1.BrandMetaData, { csp: this.props.csp }),
                        React.createElement(metadata_helper_1.NameMetaData, { csp: this.props.csp }),
                        React.createElement(metadata_helper_1.PriceMetaData, { csp: this.props.csp }),
                        React.createElement(core_link_1.default, { className: "csp-vertical-feature__shop-link", to: csp.webLink.href, entityId: csp.id, position: this.props.position }, I18n.t('cms.cspFeature.shopNow'))))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    CspVerticalFeature = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                mParticleInteraction: function (data) { return tracker_1.trackCSPClick(data, props.csp, { displayStyle: COMPONENT_NAME }); },
            };
        })
    ], CspVerticalFeature);
    return CspVerticalFeature;
}(React.Component));
exports.default = CspVerticalFeature;
//# sourceMappingURL=csp_vertical_feature.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/csp_vertical_feature.js
// module id = KU7O
// module chunks = 20 21